import { getThresholdChangeActions } from "./action";

const initialState = {
  getThresholdData: "",
};

const getThresholdChangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case getThresholdChangeActions.GET_THRESHOLD_CHANGE_SUCCESS:
      return {
        ...state,
        getThresholdData: action.payload.data,
      };
    case getThresholdChangeActions.GET_THRESHOLD_CHANGE_ERROR:
      return {
        ...state,
        getThresholdData: [],
      };

    default:
      return state;
  }
};

export default getThresholdChangeReducer;
